//毕业意向
import React, { useState, useRef, useEffect } from 'react';
import { Cascader, message } from 'antd';
import { ExclamationCircleOutlined, CheckCircleOutlined, DownOutlined } from '@ant-design/icons';
import styles from './optional1.module.scss';
import setRequiredFields from './GaokaoxkStore'
import { SVGPureIcon } from "@/ui";
import { observer } from 'mobx-react-lite';


const options = [
  { value: '就业', label: '就业' },
  { value: '考研', label: '考研' },
  { value: '出国', label: '出国' },
  { value: '考公', label: '考公' },
];

const GraduationIntention = (props) => {

  const [selectedValues, setSelectedValues] = useState([]);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const onChange = (value) => {
    const result = [].concat(...value);
    setSelectedValues(value);
    setRequiredFields.setOptionalFields({
      graduationIntention: result, // 更新 classification 属性
    });
    setRequiredFields.setOptionalFields({
      graduationIntention1: value
    });
  };

  const handleDropdownVisibleChange = (visible) => {
    if (visible) {
      setDropdownVisible(true);
    } else {
      // 直接关闭下拉框，不再恢复上次选择
      setDropdownVisible(false);

    }
  };


  const tagRender = (props) => {
    const { label, closable, onClose } = props;

    const handleClose = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };
    const graduationIntentionList =setRequiredFields?.optionalFields?.graduationIntention

    return (
      <span className="custom-tag" style={{ color: '#006AFF', fontWeight: 700 }}>
        {label}
        {closable && graduationIntentionList?.length > 1 && graduationIntentionList?.indexOf(label) !== graduationIntentionList?.length - 1 && (
        <span className="tag-close-icon" onClick={handleClose}>
          、
        </span>
      )}
      </span>
    );
  };

  return (
    <div >
      <Cascader
        className={styles['custom-cascader']}
        popupClassName={styles['custom-cascader-dropdown']}
        style={{
          width: 'auto', // 关键：设置为 auto
          minWidth: 106, // 保留最小宽度
          display: 'inline-block' // 确保宽度自适应
        }}
        multiple
        allowClear={false}
        placeholder="毕业意向"
        options={options}
        value={setRequiredFields.optionalFields.graduationIntention1}
        onChange={onChange}
        open={dropdownVisible}
        onDropdownVisibleChange={handleDropdownVisibleChange}
        tagRender={tagRender}
        maxTagCount={2}
        maxTagPlaceholder={(omittedValues) => (
          <span style={{ color: '#006AFF' }}>
            ...
          </span>
        )}
        // 自定义选择器右侧的下拉箭头
        suffixIcon={
          <SVGPureIcon
            name={dropdownVisible ? "shangjant" : "ArrowDown"}
            className=''
            style={{ width: 16, height: 16 }}
          />
        }

        // 自定义下拉菜单中的展开箭头
        expandIcon={
          (
            <SVGPureIcon
              name="ArrowRight"
              className='text-black text-opacity-50'
              style={{
                width: 16,
                height: 16,
              }}
            />
          )
        }
        optionRender={(option, state = {}) => {
          const huoquxuanz=setRequiredFields?.optionalFields?.graduationIntention            
          
          return (
            <div style={{color:huoquxuanz?.includes(option?.label)?"#006AFF":''}}>
               {option?.label}
            </div>
          );
        }}
      />
    </div>
  );
};

export default observer(GraduationIntention);